import React, { useState, useEffect } from 'react';
import { Button, Snackbar, Box, Typography } from '@mui/material';
import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';
import { logger } from '../../services/logger';

const log = logger.createScope('AddToHomeScreen');

// Create a flag to ensure this component only runs once
let hasInitialized = false;

const AddToHomeScreen: React.FC = () => {
  const [showPrompt, setShowPrompt] = useState<boolean>(false);
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

  useEffect(() => {
    // Only run this once
    if (hasInitialized) return;
    hasInitialized = true;
    
    const handler = (e: Event) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Store the event so it can be triggered later
      setDeferredPrompt(e);
      // Show the prompt
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handler as any);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler as any);
    };
  }, []);

  const handleAddToHomeScreen = async () => {
    if (!deferredPrompt) {
      return;
    }

    // Show the install prompt
    deferredPrompt.prompt();
    
    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;
    log.debug('User response to install prompt', { outcome });
    
    // We no longer need the prompt. Clear it up
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  const handleClose = () => {
    setShowPrompt(false);
  };

  if (!showPrompt) {
    return null;
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={showPrompt}
      onClose={handleClose}
      message="Install Suprie App"
      action={
        <Box sx={{ display: 'flex', alignItems: 'center', p: 1 }}>
          <Typography variant="body2" sx={{ mr: 2 }}>
            Install this app on your device for quick and easy access when you're on the go.
          </Typography>
          <Button 
            color="primary" 
            variant="contained" 
            size="small" 
            startIcon={<AddToHomeScreenIcon />}
            onClick={handleAddToHomeScreen}
          >
            Install
          </Button>
        </Box>
      }
    />
  );
};

export default AddToHomeScreen; 